/**
 * Map de logos dos canais de comunicação em base64
 * 
 * Este arquivo centraliza os logos de cada tipo de canal suportado pelo sistema.
 * Os logos estão em formato base64 para melhor performance e não depender de URLs externas.
 * 
 * Tipos de canais suportados:
 * - whatsapp: WhatsApp
 * - interno: Sistema interno
 */

// Formato: data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA...

export const mLogosCanais = {
  // Logo temporário do WhatsApp (círculo verde com "W")
  whatsapp:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALsSURBVHgBhVTfS1RBFP7m7rpu2l2vWSqsrVumoREZIRRBqD2lhRkRBUGKReSDZCH0D5REhD7kYwgiGClEGViaZC89hRqUmYu4a2oW/th1V/fH/TGdudc1ogcHzs7OnDPf+c43Zy6DGAO5XqTIneAopZWCbYdtBBF/PWpjfrFi6HF6bbnHxzgMOszNrf8GEx6+tbSiWJCvT1egen5cgpzfruuaYugGDJ2gaIYag7yxiguuY7iWVYkCzQ4WWaZ9Bk5mzcSYu9oEqATVqIFG2GRMo521WQRO9uNLxRDcqW4C1dFx5AH06q84QAnsggbtmabponzYQQ5JBQyJaEZmwS8FcGigHJN6FFxygNOhrvkR8s1AJ1/xQCV8lJsZxFzjisWEsosyBJPh8j5UvbuMyfXfeE7ZEY9SRlJDlOj0wNbtxveqESD8c+vMZjmCFgWFFlCZXYa3i2NoKbyFc+5T8PJ0CD8TRjFS2j70zg7isFxC7AkgkQQRWpBQGZKM0eVvMBy78MzXC4eUgsDKNNGkQJ2ENA3o9PXhfF41uNBPRZKJASaoJXTssKeCJTTMxaLoDQxh+OxLYGUOjfk1JPgCJCKcZkvHWjxM4IZlJojIQFRDiQ0UZ+yn4HmSgeHKcDOmQgHwm3NoK7sLft0PPbyElpIGvJjooSsWrZAsJ2GYwkmObNwffYo7pc1UHvULdqDx40OwDi8uvmkyZy924qDLgx/RiMVeZUkm9Ev18VgcVwvO4PH7VpzOLAZfIUYJKtq+G/2+QZzILMXMjVFkPimidpAtTTQNVp+oRpDpUDhRzXPlIH7vF7onX2OotgtTq366OA2FSj4+LU6AteaAKZ6tq+UWhgDh41zl5QV7jiLrURFCzAbJqaDhVRNSqdlSJBsi6gaYnAOk7yUt/r4hGPYPFkgkWs/SMDYdXFBYimI+P65RXzizkaD/wphdNktm/zxDBBGYqdt8nzRuk2YuTzudrsG2gwXJPiO8VId261PwBxtmbPWBFSgBAAAAAElFTkSuQmCC",
  interno:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ1SURBVHgBlVNNaBNBGH2zu9nd/LSNFqGltU3twRoCbrxY7MEK9eChqRe1JwkUVOjBCoLUgwgKpahI8FDEiopasIqYQxVsxZOlhRYRxUbxELAabbLJ2mSTbP7W2cQmRmiLb1mGmfm+N+/73gwBhaPjsCMt1t1hCSMBuh2boKDjWSgQOIP0XJBA7HQ0O3e91fXNEyvQwRBGYaMxN9vo6rlLAKm8Rwgi4V8wsQzqrAJYuhlV4sgkNQhmYS2IUkDMCoLEMYT0GYwGkqqKGyOncLS3C1paA1VV3GI4FhaziMHhm3g8NQ+BZ4vxLEMk0uT26qWDGYyNnEDnnnbMLn7GpSsTiERVqoTA6WzF1YsDqLHweLe0jOOnfeCoQgPMmvJwWMaBLhf804sYPD+OEE3OGqryOhbeB7HPM4xb96chOZux19VWrrhM0NpQj3w+g9FrkyXp/4A3cfDdngIviLg3dhYZLVdNkNIySKUBQTRhPRhNfPDkFaw0JhFXi2tc2RjOhN09Q+A4Fhthq70GhkDDnSoFxjyVTG+YrK5E0d+3H8s/ZNi21FYTZBIJKJ8eoqmGhxxREI8lyr0wRjkk44V/FPGkCs+RC4aF1SWcHPBAjil4M+NDLl8AT0sJfPmObysyWhrrscPRBFVN4vL1SawWKk1maxulITqKGU2D99hBPH0+h/GJl6its8G5czvaWxpgtVowuxBAd+85BII/UfiLgDRI3te0Id2EXuFkIgWLzfxHOp1TWwrZHDjeRN3h6Yohu5JMefzE0dHvyFnM//mYaPMIUb5+XHKzSuSDshqzP7Jts7fREzpKfqz/00+hl3OejymHlMhM8Dccd+wggFkhqwAAAABJRU5ErkJggg==",
}

/**
 * Retorna o logo em base64 para o tipo de canal especificado
 * 
 * @param {string} cTipoCanal - Tipo do canal ('whatsapp', 'interno', etc.)
 * @returns {string|null} - Logo em base64 ou null se não encontrado
 */
export const obterLogoCanal = (cTipoCanal) => {
  if (!cTipoCanal) return null
  
  const cTipoNormalizado = cTipoCanal.toLowerCase().trim()
  return mLogosCanais[cTipoNormalizado] || null
}

/**
 * Verifica se um tipo de canal é válido/suportado
 * 
 * @param {string} cTipoCanal - Tipo do canal a verificar
 * @returns {boolean} - true se o canal é suportado
 */
export const lCanalValido = (cTipoCanal) => {
  if (!cTipoCanal) return false
  
  const cTipoNormalizado = cTipoCanal.toLowerCase().trim()
  return Object.prototype.hasOwnProperty.call(mLogosCanais, cTipoNormalizado)
}

/**
 * Retorna lista de todos os tipos de canais suportados
 * 
 * @returns {string[]} - Array com os tipos de canais
 */
export const obterCanaisSuportados = () => {
  return Object.keys(mLogosCanais)
}

export default mLogosCanais
